import React,{useState} from 'react'
import {
    MenuItem,
    Menu,
  } from "@mui/material";
  import { useTranslation } from "react-i18next";
  import LanguageIcon from '@mui/icons-material/Language';
export default function Language() {
    const [open, setOpen] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const { i18n } = useTranslation();
    const { t } = useTranslation();
    const handleOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        handleClose();
      };

    const handleClose = () => {
        setAnchorEl(null);
    };
  return (
    <div>
        <LanguageIcon sx={{ color:'gray',cursor:'pointer' }} onClick={handleOpen}/>
        <Menu
              sx={{ marginRight:'100px',marginTop:'15px' }}
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={() => changeLanguage("en")}>
                {t('English')}
              </MenuItem>
              <MenuItem onClick={() => changeLanguage("ar")}>
                {t('Arabic')}
              </MenuItem>
            </Menu>
    </div>
  )
}
